import React from 'react';

function Privat() {
  return (
    <div
      className="container d-flex justify-content-center align-items-center"
      style={{ minHeight: '100vh' }}
      dir="rtl"
    >
      <div className="card p-4 shadow" style={{ maxWidth: '500px', width: '100%' }}>
        <h2 className="text-center mb-3">האזור האישי</h2>
        <h5 className="text-center mb-4">כאן ניתן להוסיף או להסיר תמונה</h5>

        <div className="d-grid gap-3">
          <a href="/create" className="btn btn-success">
            ➕ הוספת מוצר
          </a>
          <a href="/delete" className="btn btn-danger">
            ❌ הסרת מוצר
          </a>
          <a href="/updatename" className="btn btn-outline-primary">
            ✏️ עריכת פרטים אישיים
          </a>
        </div>
      </div>
    </div>
  );
}

export default Privat;
